function ComplaintsReducer(state = {
    complaintsMainGroups: [], complaintsSubGroups: [], complaintsTargetList: [],
    complaintList: [], complaintStatusList: [], complaintFilters: {}
}, action) {
    switch (action.type) {
        case "GET_COMPLAINT_MAINGROUP":
            return {
                ...state,
                complaintsMainGroups: action.data
            }
        case "GET_COMPLAINT_SUBGROUP":
            return {
                ...state,
                complaintsSubGroups: action.data
            }
        case "GET_COMPLAINT_TARGETS":
            return {
                ...state,
                complaintsTargetList: action.data
            }
        case "SEARCH_COMPLAINTS":
            return {
                ...state,
                complaintList: action.data
            }
        case "COMPLAINT_STATUS_LIST":
            return {
                ...state,
                complaintStatusList: action.data
            }
        case "COMPLAINT_FILTERS":
            return {
                ...state,
                complaintFilters: action.data
            }
        case "W_SMS_WEB_REQ_FILTERS":
            return {
                ...state,
                waitingSMSOrWebRequestsFilters: action.data
            }
        case "W_SMS_WEB_REQ":
            return {
                ...state,
                waitingSMSOrWebRequests: action.data
            }
        default:
            return state;
    }
}
export default ComplaintsReducer;